// app_client/src/store/roleStore.js
import { create } from 'zustand';
import axios from 'axios';
import useAuthStore from './authStore';

const permissionFields = ['read', 'write', 'delete', 'assign', 'canViewAll', 'viewAll'];

const normalizeRoleName = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/ı/g, 'i')
  .replace(/[^a-z0-9]/g, '');

const shouldHideGhostRoles = () => normalizeRoleName(useAuthStore.getState().user?.roleName) !== 'superadmin';

const filterGhostRoles = (roles = []) => {
  if (!shouldHideGhostRoles()) return Array.isArray(roles) ? roles : [];
  return (Array.isArray(roles) ? roles : []).filter((role) => normalizeRoleName(role?.name) !== 'superadmin');
};

const getModuleId = (permission) => permission?.moduleId?._id || permission?.moduleId;

const normalizeRolePayload = (roleData) => ({
  ...roleData,
  permissions: (roleData.permissions || [])
    .map((permission) => {
      const moduleId = getModuleId(permission);
      if (!moduleId) return null;

      return {
        moduleId,
        moduleName: permission.moduleName || permission.moduleId?.name || '',
        ...permissionFields.reduce((payload, field) => ({
          ...payload,
          [field]: Boolean(permission[field])
        }), {})
      };
    })
    .filter(Boolean)
});

const useRoleStore = create((set, get) => ({
  roles: [],
  modules: [], // Sistemdeki tüm modüller (Finance, Storage vb.)
  loading: false,

  fetchInitialData: async () => {
    set({ loading: true });
    try {
      const [rolesRes, modulesRes] = await Promise.all([
        axios.get('/api/roles'),
        axios.get('/api/modules')
      ]);
      set({ roles: filterGhostRoles(rolesRes.data), modules: modulesRes.data, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  saveRole: async (roleData) => {
    try {
      const payload = normalizeRolePayload(roleData);

      if (roleData._id) {
        await axios.put(`/api/roles/${roleData._id}`, payload);
      } else {
        await axios.post('/api/roles', payload);
      }
      get().fetchInitialData();
      return { success: true };
    } catch {
      return { success: false };
    }
  },

  deleteRole: async (id) => {
    try {
      await axios.delete(`/api/roles/${id}`);
      await get().fetchInitialData();
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "Rol silinemedi" };
    }
  }
}));

export default useRoleStore;
